<template>
  <!-- Start Design & Development Services -->
  <section class="services-area ptb-80">
    <div class="container">
      <div class="row h-100 justify-content-center align-items-center">
        <div class="col-lg-6 col-md-12 services-left-image">
          <img src="../../assets/img/services-left-image/big-monitor.png" class="wow fadeInDown" alt="big-monitor" />
          <img src="../../assets/img/services-left-image/creative.png" class="wow fadeInUp" alt="creative" />
          <img src="../../assets/img/services-left-image/developer.png" class="wow fadeInLeft" alt="developer" />
          <img src="../../assets/img/services-left-image/flower-top.png" class="wow zoomIn" alt="flower-top" />
          <img src="../../assets/img/services-left-image/small-monitor.png" class="wow bounceIn" alt="small-monitor" />
          <img src="../../assets/img/services-left-image/small-top.png" class="wow fadeInDown" alt="small-top" />
          <img src="../../assets/img/services-left-image/table.png" class="wow zoomIn" alt="table" />
          <img src="../../assets/img/services-left-image/target.png" class="wow fadeInUp" alt="target" />
          <img src="../../assets/img/services-left-image/cercle-shape.png" class="bg-image rotateme" alt="IT+ formation cours informatique djibouti" />

          <img src="../../assets/img/services-left-image/main-pic.png" class="wow fadeInUp" alt="main-pic" />
        </div>

        <div class="col-lg-6 col-md-12 services-content">
          <div class="section-title">
            <h2>Cours et formations en Programmation informatique</h2>
            <div class="bar"></div>
            <p>
              Le domaine de la programmation est un domaine tres vaste, créatif,
              remplie de défis et extremement rémunerateur. L'evolution
              constante des technologies et des demandes, augmente la complexité
              des solutions et requiert aux developpeur informatiques d'etre de
              plus en plus innovant. Apprenez les bases de la programmation
              informatiques, découvrez les dernieres technologies, et mettez
              toutes les chances de vos cotés afin de créer les solutions de
              demain.
            </p>
          </div>

          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="box">
                <vue-feather type="layout"></vue-feather> HTML5 et CSS3
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="box">
                <vue-feather type="code"></vue-feather> Javascript
              </div>
            </div>
            <!--
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="box"><vue-feather type="code"></vue-feather> Java</div>
            </div> -->

            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="box">
                <vue-feather type="code"></vue-feather> Vue.js et Angular2+
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="box">
                <vue-feather type="code"></vue-feather> Node.js
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="box">
                <vue-feather type="database"></vue-feather> SQL et NoSQL
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="box">
                <vue-feather type="check-circle"></vue-feather> Et bien plus encore!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End Design & Development Services -->
</template>
